import { useState } from 'react';
import { useRegion, useRegions } from '#hooks';
import { Modal } from '#ui-kit';
import { Head } from '#components';
import { HeadUnderlineVariant } from '#components.types';
import RegionsTable from './containers/RegionsTable';
import RegionForm from 'pages/Region/containers/RegionForm';
import { RegionFormInitialValues } from 'pages/Region/containers/RegionForm/types';

export default () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const {
    data,
    loading,
    page,
    size,
    total,
    isLast,
    setPage,
    setSize,
    getRegions,
  } = useRegions();

  const { createRegion } = useRegion();

  const handleCreateRegion = async (values: RegionFormInitialValues) => {
    await createRegion(values);

    setIsCreateModalOpen(false);

    await getRegions();
  };

  return (
    <>
      <Head
        {...{
          label: 'Регионы',
          underlineVariant: HeadUnderlineVariant.Primary,
          button: {
            label: 'Добавить регион',
            onClick: () => setIsCreateModalOpen(true),
          },
        }}
      />
      <RegionsTable
        {...{ data, loading, page, size, total, isLast, setPage, setSize }}
      />
      <Modal
        open={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      >
        <RegionForm loading={loading} onSubmit={handleCreateRegion} />
      </Modal>
    </>
  );
};
